<div class="homr-text-link-container hmf-justify-content-center hmf-text-align-center hmf-display-flex hmf-mb-m hmf-py-xs" >
  @if (link) {
    <a href="{{ link }}" class="homr-text-link" data-em="homr-freeShipMessage" target="_blank">{{ message }}</a>
  } @else {
    <span class="message-text border">{{ message }}</span>
  }
</div>
